import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step6 } from '../../../../../shared/models/component-messages/mapaIN/step6';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { CTRL_16 } from '../../../../validators/16/ctrl16';
import { Initial } from '../../models/Initial';
import { MapaINControlNames } from '../../service/mapaINControleNames';

@Component({
  selector: 'app-step6',
  templateUrl: './step6.component.html'
})
export class Step6Component implements OnInit {

  private LOG: LogService = new LogService(Step6Component);

	@Input() initial: Initial;

	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	

	@Input() uid = '';

    public rg1 = CTRL_16.id + '_1';

	public step6 = new Step6();

	@Input() linkForRouter: string;

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
	) { }


  ngOnInit(): void {
	this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_16Names_json() }));
  }

  public getUid() {
		return this.uid;
	}

	getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}
}
